<template>
  <div class="flex flex-col mx-23.5">
    <sectionHeader v-if="headerIndex" :text="content[headerIndex]" />
    <div class="content flex flex-col gap-7.5">
      <div v-for="contentPart in Object.entries(content)" :key="contentPart[0]">
        <textElement v-if="contentPart[0].includes('textElement')" :text="contentPart[1]"/>
        <numberedList v-else-if="contentPart[0].includes('numberedList')" :items="contentPart[1]"/>
        <markedList v-else-if="contentPart[0].includes('markedList')" :items="contentPart[1]"/>
        <miniMarkedList v-else-if="contentPart[0].includes('miniMarkedList')" :items="contentPart[1]"/>
      </div>
    </div>
  </div>
</template>

<script>
import sectionHeader from "@/components/tablet/blog/postElements/sectionHeader";
import numberedList from "@/components/tablet/blog/postElements/numberedList";
import markedList from "@/components/tablet/blog/postElements/markedList";
import miniMarkedList from "@/components/tablet/blog/postElements/miniMarkedList";
import textElement from "@/components/tablet/blog/postElements/textElement";

export default {
  name: "postSection",
  components:{
    sectionHeader,
    numberedList,
    markedList,
    miniMarkedList,
    textElement
  },
  props: ['content'],
  computed:{
    headerIndex(){
      let result = null
      Object.keys(this.content).forEach(key => {
        if (key.includes('sectionHeader')){
          result = key
        }
      })
      return result
    }
  }
}
</script>

<style scoped>

</style>